import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { taskPropType } from './kanbanTaskConstants';

// Built on demand so a long-lived session does not keep the date from when the module loaded
const buildEmptyTaskForm = () => ({ title: '', description: '', executionDate: dayjs() });

export default function KanbanTaskCardModal({ open, task, onClose, onSave }) {
  const [taskForm, setTaskForm] = useState(buildEmptyTaskForm);

  useEffect(() => {
    if (open) {
      setTaskForm(
        task
          ? {
              title: task.title,
              description: task.description || '',
              executionDate: task.executionDate,
            }
          : buildEmptyTaskForm(),
      );
    }
  }, [open, task]);

  const handleTaskFieldChange = (field, value) => {
    setTaskForm((previous) => ({ ...previous, [field]: value }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{task ? 'Editar tarefa' : 'Nova tarefa'}</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="Título"
            value={taskForm.title}
            onChange={(event) => handleTaskFieldChange('title', event.target.value)}
            fullWidth
            autoFocus
          />
          <TextField
            label="Descrição"
            value={taskForm.description}
            onChange={(event) => handleTaskFieldChange('description', event.target.value)}
            fullWidth
            multiline
            minRows={2}
          />
          <DatePicker
            label="Data de Execução"
            value={taskForm.executionDate}
            onChange={(date) => handleTaskFieldChange('executionDate', date)}
            format="DD/MM/YYYY"
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          onClick={() => onSave(taskForm)}
          disabled={!taskForm.title.trim()}
        >
          {task ? 'Salvar' : 'Adicionar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

KanbanTaskCardModal.propTypes = {
  open: PropTypes.bool.isRequired,
  task: taskPropType,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

KanbanTaskCardModal.defaultProps = {
  task: null,
};
